import React from 'react';
import Picker, { IEmojiData } from 'emoji-picker-react';
import { Popover, SvgIcon } from '@mui/material';
import { EmojiEmotions as EmojiEmotionsIcon, EmojiEmotionsOutlined as EmojiEmotionsOutlinedIcon } from '@mui/icons-material';
import { IProps } from './interfaces';
import { MEDIUM_GREY, DARK_GREY } from '../../../../VirtualClipper/constants/theme';
import { ActionContainer, DialogActionsOverride } from '../../../styles/dialog';

const styles = {
  OutlinedEmojiButton: {
    cssFloat: 'right',
    cursor: 'pointer',
    fontSize: 'x-large',
    color: MEDIUM_GREY,
  },
  FilledEmojiButton: {
    cssFloat: 'right',
    cursor: 'pointer',
    fontSize: 'x-large',
    color: DARK_GREY,
  },
};

export default function EmojiSelector(props: IProps) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [iconToggle, setIconToggle] = React.useState(true);
  const open = Boolean(anchorEl);
  const id = open ? 'emoji-picker' : undefined;

  const handleIconToggle = () => {
    if (!open) {
      setIconToggle(((prevState) => !prevState));
    }
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIconToggle(true);
  };

  const setEmoji = (event: React.MouseEvent, data: IEmojiData) => {
    const { fieldName, value, updateFunction } = props;
    const newValue = value + data.emoji;
    updateFunction(fieldName, newValue);
  };

  return (
    <DialogActionsOverride>
      <ActionContainer>
        {iconToggle
          ? (<SvgIcon id={id} style={styles.OutlinedEmojiButton} component={EmojiEmotionsOutlinedIcon} onClick={handleClick} onMouseEnter={handleIconToggle} />)
          : (<SvgIcon id={id} style={styles.FilledEmojiButton} component={EmojiEmotionsIcon} onClick={handleClick} onMouseLeave={handleIconToggle} />
          )}
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Picker onEmojiClick={setEmoji} />
        </Popover>
      </ActionContainer>
    </DialogActionsOverride>
  );
}
